import React from 'react';
import { Dialog } from 'primereact/dialog';
import { defineMessages, useIntl } from 'react-intl';
import { Button } from 'primereact/button';
import { UnsettledCommissionType } from '../../../shared/Constants';

const i18nMessages = defineMessages({
  unsettledCommissionBetweenGscAndGpiDialogHeader: {
    id: 'agreed-commission-dialog.unsettled-comssion-gsc-gpi.header',
    defaultMessage: 'You must invoice unsettled commission first',
  },
  unsettledCommissionBetweenGscAndGpiFirstParagraph: {
    id: 'agreed-commission-dialog.unsettled-comssion-gsc-gpi.first-paragraph',
    defaultMessage:
      'You have unsettled commission which affects this GP. It must be settled before you can change the commission percentages.',
  },
  unsettledCommissionBetweenGscAndGpiSecondParagraph: {
    id: 'agreed-commission-dialog.unsettled-comssion-gsc-gpi.second-paragraph',
    defaultMessage:
      'Therefore, invoice GPI your unsettled commission. Then ask your GP to invoice you. Once done, you can return and change the agreed commissions. The new commission percentages apply from that point forward and until you change them again.',
  },
  unsettledCommissionBetweenGscAndGpDialogHeader: {
    id: 'agreed-commission-dialog.unsettled-comssion-gsc-gp.header',
    defaultMessage: '{name} - action required',
  },
  unsettledCommissionBetweenGscAndGpFirstParagraph: {
    id: 'agreed-commission-dialog.unsettled-comssion-gsc-gp.first-paragraph',
    defaultMessage:
      '{name} has unsettled commission based on the presently agreed commission percentages. It must be settled before you can change the commission percentages.',
  },
  unsettledCommissionBetweenGscAndGpSecondParagraph: {
    id: 'agreed-commission-dialog.unsettled-comssion-gsc-gp.second-paragraph',
    defaultMessage:
      'Therefore, ask {name} to invoice you. Once done, you can return and change the agreed commissions. The new commission percentages apply from that point forward until you change them again.',
  },
  gotIt: {
    id: 'user-notification-dialog.button',
    defaultMessage: 'Got it',
  },
});

const UnsettledCommissionNotice = ({ selectedPartner, closeDialog }) => {
  const { formatMessage } = useIntl();

  if (!selectedPartner) return null;

  const { name, unsettledCommissionType } = selectedPartner;

  const getDialogHeader = () => {
    if (unsettledCommissionType === UnsettledCommissionType.BETWEEN_GSC_AND_GPI) {
      return formatMessage(i18nMessages.unsettledCommissionBetweenGscAndGpiDialogHeader);
    } else if (unsettledCommissionType === UnsettledCommissionType.BETWEEN_GSC_AND_GP) {
      return formatMessage(i18nMessages.unsettledCommissionBetweenGscAndGpDialogHeader, { name });
    } else {
      return null;
    }
  };

  const getFirstParagraph = () => {
    if (unsettledCommissionType === UnsettledCommissionType.BETWEEN_GSC_AND_GPI) {
      return formatMessage(i18nMessages.unsettledCommissionBetweenGscAndGpiFirstParagraph);
    } else if (unsettledCommissionType === UnsettledCommissionType.BETWEEN_GSC_AND_GP) {
      return formatMessage(i18nMessages.unsettledCommissionBetweenGscAndGpFirstParagraph, { name });
    } else {
      return null;
    }
  };

  const getSecondParagraph = () => {
    if (unsettledCommissionType === UnsettledCommissionType.BETWEEN_GSC_AND_GPI) {
      return formatMessage(i18nMessages.unsettledCommissionBetweenGscAndGpiSecondParagraph);
    } else if (unsettledCommissionType === UnsettledCommissionType.BETWEEN_GSC_AND_GP) {
      return formatMessage(i18nMessages.unsettledCommissionBetweenGscAndGpSecondParagraph, { name });
    } else {
      return null;
    }
  };

  return (
    <Dialog visible={!!selectedPartner} closable={false} header={getDialogHeader()} onHide={() => {}}>
      <p>{getFirstParagraph()}</p>
      <p>{getSecondParagraph()}</p>
      <div className="flex-center">
        <Button
          type="button"
          className="p-button-primary"
          onClick={closeDialog}
          label={formatMessage(i18nMessages.gotIt)}
        />
      </div>
    </Dialog>
  );
};

export default UnsettledCommissionNotice;
